export const emailTemplate = function (body, buttonTitle, link, styles, isSidekickApp) {
    return `
<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN"
        "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml"
      xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
    <!--[if gte mso 9]>
    <xml>
        <o:OfficeDocumentSettings>
            <o:AllowPNG/>
            <o:PixelsPerInch>96</o:PixelsPerInch>
        </o:OfficeDocumentSettings>
    </xml>
    <![endif]-->
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta name="x-apple-disable-message-reformatting">
    <!--[if !mso]><!-->
    <meta http-equiv="X-UA-Compatible" content="IE=edge"><!--<![endif]-->
    <link href="https://fonts.googleapis.com/css?family=Nunito" rel="stylesheet" type="text/css">
    <title></title>
    <style type="text/css">
        body {
            margin: 0;
            padding: 0;
        }

        table, tr, td {
            vertical-align: top;
            border-collapse: collapse;
        }

        p, ul {
            margin: 0;
        }

        .ie-container table, .mso-container table {
            table-layout: fixed;
        }

        * {
            line-height: inherit;
        }
        
        .email-body-bg {
            background-position: bottom 35px right 35px;
            background-size: 40% auto;
            background-repeat: no-repeat;
            background-image: url(${isSidekickApp ? '' : styles.bodyBg});
        }

        a[x-apple-data-detectors=true] {
            color: inherit !important;
            text-decoration: none !important;
        }

        .ExternalClass, .ExternalClass p, .ExternalClass span, .ExternalClass font, .ExternalClass td, .ExternalClass div {
            line-height: 100%;
        }

        [owa] .email-row .email-col {
            display: table-cell;
            float: none !important;
            vertical-align: top;
        }

        .ie-container .email-col-100, .ie-container .email-row, [owa] .email-col-100, [owa] .email-row {
            width: 500px !important;
        }

        .ie-container .email-col-17, [owa] .email-col-17 {
            width: 85px !important;
        }

        .ie-container .email-col-25, [owa] .email-col-25 {
            width: 125px !important;
        }

        .ie-container .email-col-33, [owa] .email-col-33 {
            width: 165px !important;
        }

        .ie-container .email-col-50, [owa] .email-col-50 {
            width: 250px !important;
        }

        .ie-container .email-col-67, [owa] .email-col-67 {
            width: 335px !important;
        }

        @media only screen and (min-width: 520px) {
            .email-row {
                width: 600px !important;
            }

            .email-row .email-col {
                vertical-align: top;
            }

            .email-row .email-col-100 {
                width: 500px !important;
            }

            .email-row .email-col-67 {
                width: 335px !important;
            }

            .email-row .email-col-50 {
                width: 250px !important;
            }

            .email-row .email-col-33 {
                width: 165px !important;
            }

            .email-row .email-col-25 {
                width: 125px !important;
            }

            .email-row .email-col-17 {
                width: 85px !important;
            }
        }

        @media (max-width: 520px) {
            .hide-mobile {
                display: none !important;
            }

            .email-row-container {
                padding-left: 0px !important;
                padding-right: 0px !important;
            }

            .email-row .email-col {
                min-width: 320px !important;
                max-width: 100% !important;
                display: block !important;
            }

            .email-row {
                width: calc(100% - 40px) !important;
            }

            .email-col {
                width: 100% !important;
            }

            .email-col > div {
                margin: 0 auto;
            }

            .no-stack .email-col {
                min-width: 0 !important;
                display: table-cell !important;
            }

            .no-stack .email-col-50 {
                width: 50% !important;
            }

            .no-stack .email-col-33 {
                width: 33% !important;
            }

            .no-stack .email-col-67 {
                width: 67% !important;
            }

            .no-stack .email-col-25 {
                width: 25% !important;
            }

            .no-stack .email-col-17 {
                width: 17% !important;
            }
        }
        
        .body-text {
            font-family: 'Nunito', sans-serif !important;
            color: #000000;
            font-size: 22px;
            font-weight: 400;
            margin-bottom: 30px;
            line-height: 22px;
        }
        h1.body-text {
            font-family: 'Nunito', sans-serif !important;
            font-size: 22px;
            font-weight: 400;
            line-height: 22px;
        }
        p.body-text {
            font-family: 'Nunito', sans-serif !important;
            font-size: 18px;
            font-weight: 400;
        }
        p.body-text a {
            font-size: 18px;
            color: #347aff;
            font-weight: 400;
            text-decoration: blink;
        }
        b.body-text {
            font-size: 22px;
            font-weight: 700;
            line-height: 22px;
        }
        
        .action-button-text {
            color: #ffffff;
            font-family: Nunito, sans-serif !important;
            font-size: 18px;
            font-weight: 400;
            line-height: 20px;
            margin-right: 5px;
        }
        
        .action-button-icon {
            position: relative;
            top: 2px;
        }

    </style>

    <!--[if mso]>
    <style type="text/css">
        ul li {
            list-style: disc inside;
            mso-special-format: bullet;
        }
    </style>
    <![endif]-->

</head>

<body class="clean-body" style="margin: 0;padding: 0;-webkit-text-size-adjust: 100%;background-color: #ebebeb">
<!--[if IE]>
<div class="ie-container"><![endif]-->
<!--[if mso]>
<div class="mso-container"><![endif]-->
<table class="nl-container"
       style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;min-width: 320px;Margin: 0 auto;background-color: #ebebeb;width:100%"
       cellpadding="0" cellspacing="0">
    <tbody>
    <tr style="vertical-align: top">
        <td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top">
            <!--[if (mso)|(IE)]>
            <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr>
                    <td align="center" style="background-color: #ebebeb;"><![endif]-->
            <div style="background-color: #FFFFFF; border-radius: 10px; overflow: hidden; justify-content: space-between; max-width: 700px; margin: 50px auto;">

                <div style="width: 100%; display: flex; min-height: 34px; background-color: ${
                    isSidekickApp ? '#1B1C1B' : styles.headerColor
                }; ">
                    <div style="width: 200px; text-align: center; background-color: ${
                        isSidekickApp ? '#1B1C1B' : styles.logoColor
                    }; border-bottom-right-radius: 10px; padding-top: 10px; padding-bottom: 10px;">
                        <img src=${
                            isSidekickApp
                                ? 'https://firebasestorage.googleapis.com/v0/b/validate-web-platform.appspot.com/o/static%2Fsidekick-logo.png?alt=media&token=605fc0bd-f60f-4f6f-a078-52060bdff4d5'
                                : '"https://firebasestorage.googleapis.com/v0/b/validate-web-platform.appspot.com/o/static%2Flogo.png?alt=media&token=1f3eaf14-4cf8-4b0b-bf64-354cddcef719"'
                        } alt="validate_logo" style="height: 34px; width: auto;"/>
                    </div>
                </div>

                <div class="email-body-bg">
                <div class="email-row-container" style="padding: 0px;background-color: transparent; min-height: 260px;">
                    <div style="Margin: 0 auto; min-height: 100px; min-width: 320px;max-width: 700px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: transparent;"
                         class="email-row">
                        <div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;">
                            <!--[if (mso)|(IE)]>
                            <table width="100%" cellpadding="0" cellspacing="0" border="0">
                                <tr>
                                    <td style="padding: 0px;background-color: transparent;" align="center">
                                        <table cellpadding="0" cellspacing="0" border="0" style="width:500px;">
                                            <tr style="background-color: transparent;"><![endif]-->

                            <!--[if (mso)|(IE)]>
                            <td align="center" width="500"
                                style="width: 500px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"
                                valign="top"><![endif]-->
                            <div class="email-col email-col-100"
                                 style="max-width: 320px;min-width: 500px;display: table-cell;vertical-align: top;">
                                <div style="width: 100% !important;">
                                    <!--[if (!mso)&(!IE)]><!-->
                                    <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;">
                                        <!--<![endif]-->

                                        <table id="u_content_text_1" class="u_content_text"
                                               style="font-family:arial,helvetica,sans-serif;" role="presentation"
                                               cellpadding="0" cellspacing="0" width="100%" border="0">
                                            <tbody>
                                            <tr>
                                                <td style="overflow-wrap:break-word;word-break:break-word;font-family:arial,helvetica,sans-serif;" align="left">
                                                    <div class="body-text" style="text-align: left; word-wrap: break-word; padding-top: 50px; padding-bottom: 50px; margin-bottom: 0px;">
                                                        ${body}
                                                        <p class="body-text" style="margin-bottom: 0px">
                                                          <b>Rupert Mason</b>
                                                        </p>
                                                        <p class="body-text" style="margin-bottom: 0px">
                                                          <b>CEO & Founder of Sidekick Studios</b>
                                                        </p>
                                                        <img src="https://firebasestorage.googleapis.com/v0/b/validate-web-platform.appspot.com/o/static%2Fsign-for-letter.png?alt=media&token=30968ce4-3afd-4638-8975-1cc7f557fc6b" alt="sign">
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                        <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]-->
                                </div>
                            </div>
                            <!--[if (mso)|(IE)]></td><![endif]-->
                            <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]-->
                        </div>
                    </div>
                </div>
                ${
                    buttonTitle.length !== 0
                        ? `
                        <div class="email-row-container" style="padding: 0px;background-color: transparent; min-height: 74px;">
                            <div style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: transparent;"
                                 class="email-row">
                                <div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;">
                                    <!--[if (mso)|(IE)]>
                                    <table width="100%" cellpadding="0" cellspacing="0" border="0">
                                        <tr>
                                            <td style="padding: 0px;background-color: transparent;" align="center">
                                                <table cellpadding="0" cellspacing="0" border="0" style="width:500px;">
                                                    <tr style="background-color: transparent;"><![endif]-->
        
                                    <!--[if (mso)|(IE)]>
                                    <td align="center" width="500"
                                        style="width: 500px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"
                                        valign="top"><![endif]-->
                                    <div class="email-col email-col-100"
                                         style="max-width: 320px;min-width: 500px;display: table-cell;vertical-align: top;">
                                        <div style="width: 100% !important;">
                                            <!--[if (!mso)&(!IE)]><!-->
                                            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;">
                                                <!--<![endif]-->
        
                                                <table id="u_content_button_2" class="u_content_button"
                                                       style="font-family:arial,helvetica,sans-serif;" role="presentation"
                                                       cellpadding="0" cellspacing="0" width="100%" border="0">
                                                    <tbody>
                                                    <tr>
                                                        <td style="overflow-wrap:break-word;word-break:break-word;"
                                                            align="left">
        
                                                            <div align="left">
                                                                <!--[if mso]>
                                                                <table width="100%" cellpadding="0" cellspacing="0" border="0"
                                                                       style="border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;font-family:arial,helvetica,sans-serif;">
                                                                    <tr>
                                                                        <td style="font-family:arial,helvetica,sans-serif;"
                                                                            align="left">
                                                                            <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml"
                                                                                         xmlns:w="urn:schemas-microsoft-com:office:word"
                                                                                         href="link"
                                                                                         style="height:36px; v-text-anchor:middle; width:110px;"
                                                                                         arcsize="33.5%" stroke="f"
                                                                                         fillcolor="#6da3fa">
                                                                                <w:anchorlock/>
                                                                                <center style="color:#FFFFFF;font-family:arial,helvetica,sans-serif;">
                                                                <![endif]-->
                                                                <a href="${link}" target="_self"
                                                                   style="display: inline-block;font-family:arial,helvetica,sans-serif;text-decoration: none;-webkit-text-size-adjust: none;text-align: center;color: #FFFFFF; background-color: #383c41; border-radius: 25px; -webkit-border-radius: 25px; -moz-border-radius: 12px; width: auto; padding: 10px 20px; mso-border-alt: none;">
                                                                    <span class="action-button-text">${buttonTitle}</span>
                                                                    <img class="action-button-icon" src="https://firebasestorage.googleapis.com/v0/b/validate-web-platform.appspot.com/o/static%2Femail_arrow.png?alt=media&token=e25c5102-7554-4571-9c85-16794ec55c8a" />
                                                                </a>
                                                                <!--[if mso]></center></v:roundrect></td></tr></table>
                                                                <![endif]-->
                                                            </div>
        
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
        
                                                <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]-->
                                        </div>
                                    </div>
                                    <!--[if (mso)|(IE)]></td><![endif]-->
                                    <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]-->
                                </div>
                            </div>
                        </div>
                    </div>
                `
                        : ''
                }
                
                
            </div>

            <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
        </td>
    </tr>
    </tbody>
</table>
<!--[if (mso)|(IE)]></div><![endif]-->
</body>

</html>
`;
};

// module.exports.emailTemplate = emailTemplate;
